import React from 'react';

function SectionTitle({icon, children}) {
    return (
        <h6 className="clinic-info-section-title fw-bold text-primary mb-0">
            <i className={`bi ${icon} me-2`}/>
            {children}
        </h6>
    );
}

function InfoField({icon, label, children, iconClassName = 'text-muted', colClass = 'col-md-6'}) {
    return (
        <div className={colClass}>
            <div className="clinic-info-field">
                <i className={`bi ${icon} clinic-info-field-icon ${iconClassName}`}/>
                <div className="flex-grow-1 min-w-0">
                    <h6 className="clinic-info-field-label">{label}</h6>
                    <p className="clinic-info-field-value fw-normal">{children}</p>
                </div>
            </div>
        </div>
    );
}

function GatewayClinicInfoText({clinicInfo}) {
    if (!clinicInfo) return null;

    return (
        <div className="clinic-info-content">
            <section className="clinic-info-form-section">
                <SectionTitle icon="bi-info-circle">Basic Information</SectionTitle>
                <div className="row clinic-info-fields">
                    <InfoField icon="bi-building" label="Name">{clinicInfo.name || '-'}</InfoField>
                    <InfoField icon="bi-hash" label="Clinic ID">{clinicInfo.number || '-'}</InfoField>
                    <InfoField icon="bi-envelope" label="Email">{clinicInfo.email || '-'}</InfoField>
                    <InfoField icon="bi-telephone" label="Phone">{clinicInfo.phone || '-'}</InfoField>
                    <InfoField icon="bi-chat-left-text" label="SMS">{clinicInfo.sms || '-'}</InfoField>
                    <InfoField icon="bi-pen" label="Signature">{clinicInfo.signature || '-'}</InfoField>
                    <InfoField icon="bi-globe" label="Website">
                        {clinicInfo.website ? (
                            <a href={clinicInfo.website} target="_blank" rel="noopener noreferrer">
                                {clinicInfo.website}
                            </a>
                        ) : '-'}
                    </InfoField>
                    <InfoField icon="bi-clock" label="Timezone">
                        {clinicInfo.timezone?.timezoneName || '-'}
                    </InfoField>
                </div>
            </section>

            <hr className="clinic-info-divider"/>

            <section className="clinic-info-form-section">
                <SectionTitle icon="bi-geo-alt">Address Information</SectionTitle>
                <div className="row clinic-info-fields">
                    <InfoField icon="bi-signpost" label="Street">{clinicInfo.street || '-'}</InfoField>
                    <InfoField icon="bi-building" label="City">{clinicInfo.city || '-'}</InfoField>
                    <InfoField icon="bi-mailbox" label="Postal Code">{clinicInfo.postalCode || '-'}</InfoField>
                    <InfoField icon="bi-map" label="Province">{clinicInfo.province || '-'}</InfoField>
                    <InfoField icon="bi-globe2" label="Country">{clinicInfo.country || '-'}</InfoField>
                </div>
            </section>

            <hr className="clinic-info-divider"/>

            <section>
                <SectionTitle icon="bi-shield-check">Verification Status</SectionTitle>
                <div className="row clinic-info-fields">
                    <InfoField
                        colClass="col-md-4"
                        icon={clinicInfo.verification?.email ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'}
                        label="Email Verified"
                        iconClassName=""
                    >
                        <span className="fw-semibold">{clinicInfo.verification?.email ? 'Yes' : 'No'}</span>
                    </InfoField>
                    <InfoField
                        colClass="col-md-4"
                        icon={clinicInfo.verification?.sms ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'}
                        label="SMS Verified"
                        iconClassName=""
                    >
                        <span className="fw-semibold">{clinicInfo.verification?.sms ? 'Yes' : 'No'}</span>
                    </InfoField>
                    <InfoField
                        colClass="col-md-4"
                        icon={clinicInfo.verification?.phone ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'}
                        label="Phone Verified"
                        iconClassName=""
                    >
                        <span className="fw-semibold">{clinicInfo.verification?.phone ? 'Yes' : 'No'}</span>
                    </InfoField>
                </div>
            </section>
        </div>
    );
}

export default GatewayClinicInfoText;
